<template>
    <div>

        <div class="col-md-12" v-if="viewno == 0">
            <div class="row">
                <div class="col-md-6">
                    <h3 class="page-header" style="margin-bottom: 0px;">
                        <i class="fa fa-building-o animated bounceInDown show-info"></i>

                        <span>Dispose Property List</span>
                    </h3>
                </div>
                <div class="col-md-6 text-end">
                    <button class="btn btn-primary mt-20" @click="refresh()">Refresh</button>
                </div>
            </div>
            <!-- <div class=" col-md-12 row">
                <div class="col-md-3">
                    <label class="control-label">Sub Category</label>
                     <select class="form-control form-cascade-control input-small" v-model="realestatesubcategoryid" @change="getSubCategory()">
                        <option v-for="sub in propertysubcategory" :key="sub.id" :value="sub.id">{{ sub.subcategoryname }}</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="control-label">Title</label>
                    <input class="form-control form-cascade-control input-small" v-model="title" type="text" />
                </div>
                <div class="col-md-3">
                    <label class="control-label">City</label> 
                     <select class="form-control form-cascade-control input-small" v-model="city">
                        <option v-for="city in cities" :key="city.city" :value="city.city">{{ city.city }}</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="control-label">Landmark</label>
                    <input class="form-control form-cascade-control input-small" v-model="landmark" type="text" />
                </div>
                <div class="col-md-3">
                    <label class="control-label">Reference By</label>
                    <input class="form-control form-cascade-control input-small" v-model="referenceby" type="text" />
                </div>
                <div class="col-md-3">
                    <label class="control-label">VSDIGI-ID</label>
                    <input class="form-control form-cascade-control input-small" v-model="generatedid" type="text" />
                </div>
                <div class="col-md-3">
                    <label class="control-label">Buy / Rent</label>
                     <select class="form-control form-cascade-control input-small" v-model="buyrent">
                        <option :value="1">Buy</option>
                        <option :value="2">Rent</option>
                    </select>
                </div>
            </div>
            <div class="col-md-12 mt-20">
                <button class="btn btn-primary btn-sm" @click="search()">Submit</button>
                <button class="btn btn-danger btn-sm" @click="cancel()">Cancel</button>
            </div> -->
            <div class="col-md-12 table-responsive" style="padding:0px;">
                <div class="panel">
                    <div class="panel-body table" style="overflow-x:auto;padding-left:0px">
                        <table class="table table-bordered table-font"
                            style="margin-bottom:0;font-size:15px!important;">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Sub Category</th>
                                    <th>Title</th>
                                    <th>Reference By</th>
                                    <th>Street & Pincode</th>
                                    <th>Landmark, City & State</th>
                                    <th>Youtube Link</th>
                                    <th>Contact Person</th>
                                    <th>Contact No.</th>
                                    <th>Price</th>
                                    <th>Land Unit</th>
                                    <th>Area</th>
                                    <th>Front x Length</th>
                                    <th>Buy / Rent</th>
                                    <th>Constructed</th>
                                    <th>Development Auth. Approved</th>
                                    <th>Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in properties" :key="item.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <div>{{ getSubcategory(item) }} </div>
                                        <div> 
                                            <span v-if="item.disposetype==1" class="btn btn-danger btn-xs">Sale</span> 
                                            <span v-if="item.disposetype==2" class="btn btn-warning btn-xs" > Fake</span> 
                                        </div>
                                    </td>
                                    <td>{{ item.title ? item.title : 'N/A' }}</td>
                                    <td>{{ item.referenceby!=null ? item.referenceby +'('+item.generatedid +')' : 'N/A' }}</td>
                                    <td>
                                        <span v-if="item.street != null">{{ item.street }}</span> 
                                        <span v-if="item.street != null && item.pincode != null">, </span>
                                        <span v-if="item.pincode != null">{{ item.pincode }}</span>
                                    </td>
                                    <td>
                                        <span v-if="item.landmark != null"><b>Landmark </b>: {{ item.landmark }}</span>
                                        <span v-if="item.landmark != null && item.city != null">, </span>
                                        <span v-if="item.city != null"><b>City </b>: {{ item.city }}</span>
                                        <span v-if="item.city != null && item.state > 0">, </span>
                                        <span v-if="item.state"><b>State </b>: {{ getMasterLabelByType(item.state, MASTER_STATES)
                                            }}</span>

                                    </td>
                                    <td>
                                        <div v-if="item.youtubelink.length > 0">
                                            <div v-for="(link, index) in item.youtubelink" :key="link.id">
                                                <a :href="link" target="_blank">{{ link }}</a>
                                                <span v-if="(item.youtubelink.length - index) > 1">,</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{ item.contactpersonname ? item.contactpersonname : 'N/A' }}</td>
                                    <td>
                                        <div v-if="item.contact_no?.length > 0">
                                            <div v-for="(contact, index) in item.contact_no" :key="contact.id">
                                                <span>{{ contact }}</span>
                                                <span v-if="(item.contact_no.length - index) > 1">,</span>
                                            </div>

                                        </div>
                                    </td>
                                    <td>{{ item.price ? item.price : '0.00' }}</td>
                                    <td>{{item.unit != '' && item.unit > 0 ? AREA_UNITS.find(o => o.id == item.unit)?.name
                                        : 'N/A' }}</td>
                                    <td>{{ item.area != '' && parseFloat(item.area) > 0 ? item.area : '0.00' }}</td>
                                    <td>{{ item.frontinfoot ? item.frontinfoot : '0.00' }} * {{ item.lengthinfoot ?
                                        item.lengthinfoot : '0.00' }}</td>
                                    <td>{{ item.buyrent == 1 ? 'Buy' : 'Rent' }}</td>
                                    <td>{{ item.constructed == 1 ? 'Yes' : 'NO' }}</td>
                                    <td>{{ item.iskda == 1 ? 'Yes' : 'NO' }}</td>
                                    <td>{{ item.description ? item.description : 'N/A' }}</td>
                                    <td>
                                        <!-- <button class="btn btn-primary-edit btn-active" @click="edit(item)">
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button class="btn btn-primary-print btn-active" @click="uploadImg(item)">
                                            <i class="fa fa-upload"></i></button> -->
                                        <button class="btn btn-primary-delete btn-active" @click="revert(item)" v-if="item.isdisposed==1">
                                            <i class='bx bx-undo' ></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-12" style="margin-top: 20px">
                <nav aria-label="Page navigation example" style="text-align: right !important">
                    <paginate style="margin: 0px !important; float: right" :page-count="noofpages"
                        :click-handler="clickCallback" :prev-text="'&laquo;'" :next-text="'&raquo;'"
                        :container-class="'pagination'">
                    </paginate>
                </nav>
            </div>
        </div>
        <!-- <div v-if="viewno == 1">
            <property-form :editproperty="editproperty" @close="this.cancel"></property-form>
        </div> -->
        <!-- <div v-if="viewno == 2">
            <upload-images :editproperty="editproperty" @close="this.cancel"></upload-images>
        </div> -->
        <div v-if="viewno == 3">
            <dispose-property-modal :editproperty="editproperty" @close="this.cancel" :dispose="0"></dispose-property-modal>
        </div>
    </div>
</template>
<script>
import Paginate from "vuejs-paginate";
import { mapGetters } from 'vuex'
import axios from 'axios'
// import PropertyForm from "./PropertyForm.vue";
import Constants from "../../components/utilities/Constants.vue";
// import UploadImages from "../upload/UploadImages.vue";
import DisposePropertyModal from "./DisposePropertyModal.vue";

export default {
    mixins: [Constants],
    components: { Paginate, DisposePropertyModal },
    data() {
        return {
            currentpage: 1,
            noofrec: 10,
            count: 0,
            properties: [],
            viewno: 0,
            editproperty: null,
            title: '',
            unit: 0,
            city: '',
            landmark: '',
            realestatesubcategoryid:0,
            buyrent:0,
            cities:[],
            referenceby: '',
            generatedid: '',
            isdisposed:1,
        }
    },
    computed: {
        ...mapGetters([
            'propertysubcategory'
        ]),
        noofpages() {
            return Math.ceil(parseInt(this.count) / parseInt(this.noofrec))
        }

    },
    mounted() {
        this.$store.dispatch('fetchPropertySubCategory')
        this.refresh()
        this.getAllcities()
    },
    methods: {
        clickCallback(currentpage) {
            this.currentpage = currentpage
            this.refresh();
        },
        search() {
            this.currentpage = 1
            // if (this.title != '' || this.city != '' || this.landmark != '' || this.realestatesubcategoryid > 0 || this.buyrent > 0 ) {
                this.refresh()
            // }
        },
        getAllcities(){
            axios.get('api/realestate/cities')
                .then(response => {
                    this.cities = response.data.cities
                })
                .catch(error => {
                    console.log(error)
                })
        },
        refresh() {
            let param = {
                noofrec: this.noofrec, currentpage: this.currentpage,referenceby: this.referenceby,
                generatedid: this.generatedid,isdisposed:this.isdisposed,
                title: this.title, city: this.city, landmark: this.landmark,
                realestatesubcategoryid:this.realestatesubcategoryid, buyrent:this.buyrent
            }
            axios.post('api/realestate/list', param)
                .then(response => {
                    this.count = response.data.total
                    this.properties = response.data.properties
                })
                .catch(error => {
                    console.log(error)
                })
        },
        edit(item) {
            this.viewno = 1
            this.editproperty = item
        },
        cancel() {
            this.title = ''
            this.city = ''
            this.landmark = ''
            this.viewno = 0
            this.editproperty = null
            this.realestatesubcategoryid = 0,
            this.buyrent = 0,
            this.refresh()
        },
        uploadImg(item) {
            this.viewno = 2
            this.editproperty = item
        },
        getSubcategory(item){
          
            return this.propertysubcategory.find(x => x.id == item.realestatesubcategoryid)?.subcategoryname ?? 'N/A'
        },
        revert(item) {
            this.viewno = 3
            this.editproperty = item
        },


    },
}
</script>
